import { z } from "zod";

/**
 * Assistant Schema
 * @description Schema for defining an assistant
 * @param {string} name - The name of the assistant
 * @param {string} instructions - The instructions for the assistant
 * @param {string} model - The model to use for the assistant
 * @param {array} tools - The tools to use for the assistant
 * @param {object} tool_resources - The tool resources to use for the assistant
 * @param {number} temperature - The temperature to use for the assistant
 * @param {number} top_p - The top_p to use for the assistant
 * @param {string} response_format - The response format to use for the assistant
 * @param {string} description - The description of the assistant
 * @param {object} metadata - The metadata of the assistant
 */
export const AssistantSchema = z.object({
  name: z.string().min(1, "Name is required"),
  instructions: z.string().optional(),
  model: z.string(),
  tools: z
    .array(
      z.object({
        type: z.string(),
        function: z.object({}).optional(),
        config: z.object({}).optional(),
      })
    )
    .optional(),
  // tool_resources: z.record(z.string(), z.any()).optional(),
  temperature: z.number().min(0).max(2).optional(),
  top_p: z.number().min(0).max(1).optional(),
  response_format: z
    .string()
    .refine((val) => ["text", "json_object"].includes(val), {
      message: "Response format must be either 'text' or 'json_object'",
    }),
  description: z.string().optional(),
  metadata: z.record(z.string(), z.string()).optional(),
});

export default AssistantSchema;
